module.exports = __webpack_public_path__ + "static/media/pinkVikings.301935c3.png";